// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1___483368f7e6793ae5aa8","cls2":"SimplePaperPodcast-cls2__cd7e6b53e62ec4e91fd2 SimplePaperPodcast-cls1___483368f7e6793ae5aa8"};